import React, {useEffect, useState} from 'react';
import {connect, useDispatch} from 'react-redux'
import {
    Head,
    Tree,
    ProductCategoryCreate,
    ProductCategoryMove
} from "../../../components";
import {Paper} from "@mui/material";
import {Tooltip} from "@mui/material";
import Container from "@mui/material/Container";
import IconButton from "@mui/material/IconButton";
import SyncIcon from '@mui/icons-material/Sync';
import AspectRatioIcon from '@mui/icons-material/AspectRatio';
import Grid from "@mui/material/Grid";
import { treeAction } from './../../../actions'
import {FETCH_NODES, TOGGLE_CHECKED, TOGGLE_EXPANDED} from "../../../types";
import {Link} from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import {Box} from "@mui/material";
import ScatterPlotIcon from '@mui/icons-material/ScatterPlot';
import LibraryAddIcon from '@mui/icons-material/LibraryAdd';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import CheckIcon from '@mui/icons-material/Check';
import SearchIcon from '@mui/icons-material/Search';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import Api from "../../../utils/api";
import {checked} from "../../../actions/tree";

const ProductCategory = ({fetchNodes, tree}) => {

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch({type: TOGGLE_CHECKED, payload: []});
        dispatch({type: TOGGLE_EXPANDED, payload: []});
        dispatch({type: FETCH_NODES, payload: []});
        handleRequest();
    }, []);

    const handleRequest = () => {
        fetchNodes()
    }

    const expandScrolling = (expanded, nodes) => {

        nodes.map((node) => {
            expanded.push(node.id);
            expandScrolling(expanded,node.children);
        });

        return expanded;
    }

    const handleToggleExpand = () => {

        if (tree.expanded.length === 0) {
            dispatch({type: TOGGLE_EXPANDED, payload: expandScrolling(tree.expanded, tree.nodes) });
        } else {
            dispatch({type: TOGGLE_EXPANDED, payload: []});
        }

    }


    const handleChangeSort = (type) => {
            new Api().put('/products/categories/' + tree.checked.join(',') + '/movement', {type: type}).then((response) => {
                if (typeof response !== "undefined") {
                    handleRequest();
                }
            })
    }



    return(
        <Container>
            <Head data={{ 'link': '/', 'title': 'مدیریت دسته بندی محصولات', 'description': 'دسته بندی  را مدیریت نمایید.' }} />
            <Box mt={5} mb={5}>
                <Paper style={{ padding: '0 25px 25px 25px'}}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} >
                            <p><CheckIcon style={{ position: 'relative', top:'7px'}} />دسته بندی را تا رسیدن به برند ادامه دهید.</p>
                            <p><CheckIcon style={{ position: 'relative', top:'7px'}} />در صورت انتخاب پدر کلیه ویژگی های تعیین شده ارث بری میکنند.</p>
                            <p><CheckIcon style={{ position: 'relative', top:'7px'}} />{'از دکمه'}&nbsp;<LibraryAddIcon style={{ position: 'relative', top:'7px'}} />&nbsp;{'برای قرار گرفتن برند در صفحه فروشگاه جهت فیلتر محصولات استفاده کنید.'}</p>
                            <p><CheckIcon style={{ position: 'relative', top:'7px'}} />{'از دکمه'}&nbsp;<ScatterPlotIcon style={{ position: 'relative', top:'7px'}} />&nbsp;{'برای قرار گرفتن اتریبیوت در صفحه فروشگاه جهت فیلتر محصولات استفاده کنید.'}</p>
                            <p><CheckIcon style={{ position: 'relative', top:'7px'}} />{'از دکمه'}&nbsp;<SearchIcon style={{ position: 'relative', top:'7px'}} />&nbsp;{'برای تعیین فیلترهای دلخواه هر دسته بندی استفاده کنید '}</p>
                        </Grid>
                    </Grid>
                </Paper>
            </Box>
            <Box className='display-flex display-flex-justify-content-space-between'>
                <div style={{ display: 'flex', direction: 'row', justifyContent: 'flex-start'}}>
                    {tree.checked.length === 1 && <Tooltip title="فیلتر برندها" component={Link} to={'/product/category/'+ tree.checked + '/assignable/brands'}>
                        <IconButton>
                            <LibraryAddIcon />
                        </IconButton>
                    </Tooltip>}
                    {tree.checked.length === 1 && <Tooltip title="فیلتر ویژگی ها" component={Link} to={'/product/category/'+ tree.checked + '/assignable/attributes'}>
                        <IconButton>
                            <ScatterPlotIcon />
                        </IconButton>
                    </Tooltip>}
                    {tree.checked.length === 1 && <Tooltip title="فیلتر دلخواه" component={Link} to={'/product/category/'+ tree.checked + '/assignable/filters'}>
                        <IconButton>
                            <SearchIcon />
                        </IconButton>
                    </Tooltip>}
                </div>
                <div style={{ display: 'flex', direction: 'row', justifyContent: 'flex-end'}}>
                    <ProductCategoryCreate checked={tree.checked} reload={() => handleRequest()} />
                    {tree.checked.length > 0 && <Tooltip title="تغییر اولویت">
                        <IconButton onClick={() => handleChangeSort('up')}>
                            <ArrowUpwardIcon />
                        </IconButton>
                    </Tooltip>}
                    {tree.checked.length > 0 && <Tooltip title="تغییر اولویت">
                        <IconButton onClick={() => handleChangeSort('down')}>
                            <ArrowDownwardIcon />
                        </IconButton>
                    </Tooltip>}
                    {tree.checked.length === 1 && <Tooltip title="ویرایش" component={Link} to={'/product/category/'+ tree.checked + '/edit'}>
                        <IconButton>
                            <EditIcon />
                        </IconButton>
                    </Tooltip>}
                    {tree.checked.length === 1 && <ProductCategoryMove checked={tree.checked} reload={() => handleRequest()} />}
                    <Tooltip title="باز و بسته کردن">
                        <IconButton onClick={() => handleToggleExpand()}>
                            <AspectRatioIcon />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="سینک">
                        <IconButton onClick={() => handleRequest()} >
                            <SyncIcon />
                        </IconButton>
                    </Tooltip>
                    {/*{tree.checked.length === 1 && <Tooltip title="ویرایش" component={Link} to={`/landing_page/create/${tree.checked[0]}`}>*/}
                    {/*    <IconButton>*/}
                    {/*        <EditIcon />*/}
                    {/*    </IconButton>*/}
                    {/*</Tooltip>}*/}
                </div>
            </Box>
            <Paper elevation={1}>
                <Tree nodes={tree.nodes} />
            </Paper>
        </Container>

    );
}


const mapStateToProps = state => ({
    tree: state.treeReducer
});

const mapDispatchToProps = (dispatch) => ({
    fetchNodes: () => {
        dispatch(treeAction.productCategories())
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductCategory)
